import 'jquery.payment';

export default (function ($) {


});



// WEBPACK FOOTER //
// ./resources/js/admin/payment/index.js